import { DatePipe } from '@angular/common';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CookieService } from 'src/app/core/services/cookie.service';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-viewby-id',
  templateUrl: './viewby-id.component.html',
  styleUrls: ['./viewby-id.component.scss'],
})
export class ViewbyIdComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  isdropdownShow: boolean;
  isLoading: boolean;

  dtOptions: DataTables.Settings = {};
  dtOptions1: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  submitted = false;
  user:any=[];
  currentUser: any;

  constructor(
    private datepipe: DatePipe,
    private gs: GeneralService,
    private router: Router,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private cookie: CookieService
  ) {
    this.isdropdownShow = false;
  }

  ngOnInit() {
    this.getusereppbyid();
    this.currentUser = JSON.parse(this.cookie.getCookie('currentUser'));
    this.breadCrumbItems = [
      { label: 'EPP', path: '/' },
      { label: 'View EPP', path: '/add', active: true },
    ];
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      ajax: {
        url:
          this.gs.getBaseurl() +
          `api/EppByID/${this.route.snapshot.params.UserID}`,
      },
      responsive: true,
      columns: [
        {
          title: 'Sr.No.',
          data: null,
          render: (data, type, row, meta) => {
            return meta.row + 1;
          },
        },

        {
          title: 'District',
          data: null,
          render: (data) => {
            return data.district;
          },
        },
        {
          title: 'Taluka',
          data: null,
          render: (data) => {
            if(data.BaseDocument === '0') {
              return data.taluka;
            } else {
              return 'N/A';
            }
          }
        },
        {
          title: 'Village',
          data: null,
          render: (data) => {
            if(data.BaseDocument === '0') {
              return data.village;
            } else {
              return 'N/A';
            }
          }
        },
        {
          title: 'City Survey Office',
          data: null,
          render: (data) => {
            if(data.BaseDocument === '1') {
              return data.citysurveyoffice;
            } else {
              return 'N/A';
            }
          }
        },
        {
          title: 'Ward',
          data: null,
          render: (data) => {
            if(data.BaseDocument === '1') {
              return data.ward;
            } else {
              return 'N/A';
            }
          }
        },
        {
          title: 'Sheet Number',
          data: null,
          render: (data) => {
            if(data.BaseDocument === '1') {
              return data.sheetno;
            } else {
              return 'N/A';
            }
          }
        },
        {
          title: 'Survey Number',
          data: 'survey_number',
        },
        {
          title: 'Start Date',
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.start_date, 'MMM, dd yyyy');
          },
        },
        {
          title: 'End Date',
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.end_date, 'MMM, dd yyyy');
          },
        },
        {
          title: 'Status',
          data: null,
          render: (data) => {
            // console.log(data.active);
            if (data.active === 1) {
              return 'Active';
            } else {
              return 'Inactive';
            }
            // return (data.active = '1' ? 'Active' : 'Inactive');
          },
        },
        {
          title: 'Action',
          data: null,
          render(data) {
            // <a title="Edit This Property" class="edit">
            //    <i class="btn font-18 far fa-edit text-secondary" editEppID="${data.userEPPSubscription}"></i></a>
              
            if (data.active) {
              return `<div style="display:flex">
              <a title="Deactivate This Property" class="delete" >
                  <i
                    class="font-18 mdi mdi-cancel text-secondary"
                    deleteEppID="${data.userEPPSubscription}"
                    isActive="${data.active}"
                  ></i>
                </a></div>
              `;
            }else{
              return ''
            }

            //   <a title="View This Property">
            //   <i class="btn font-18 far fa-edit text-secondary" editEppID="${data.userEPPSubscription}"></i></a>
            //   <div *ngIf ="${data.active} == 1; then ifBlock; else elseBlock" >
            //  <ng-template #ifBlock>
            //   <a title="View This Property">
            //   <i class="btn font-18 far fa-trash-alt text-secondary" deleteEppID="${data.userEPPSubscription}"></i></a>
            //   </ng-template>
            //   <ng-template #elseBlock>
            //   <a title="View This Property">
            //   <i class="btn font-18 fas fa-recycle   text-secondary" updateEppID="${data.userEPPSubscription}"></i></a>
            //   </ng-template>
            //   </div>
            //   </div>`;
          },
        },
      ],
      drawCallback: () => {
        $('.edit').on('click', (e) => {
          this.router.navigate([
            'epp/edit/' +
              this.route.snapshot.params.UserID +
              '/' +
              e.target.getAttribute('editEppID'),
          ]);
        });
        $('.delete').on('click', (e) => {
          var msg;
          var value;
          if(e.target.getAttribute('isActive') == "1") {
            msg = 'You want Deactivate this EPP ?';
            value = '0';
          } else {
            msg = 'You want Activate this EPP ?';
            value = '1';
          }
          Swal.fire({
            title: "Are you sure?",
            text: msg,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonClass: "btn btn-danger mt-2",
            cancelButtonClass: "btn btn-success ml-2 mt-2",
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              this.isLoading = true;
              const data = {
                "UserSubscriptionMainID" : e.target.getAttribute('updateTpID'),
                "isActive" : value
              }
              this.gs
            .deletbyid(e.target.getAttribute('deleteEppID'), this.currentUser.Id)
            .subscribe((data) => {
              this.isLoading = false;
              console.log(this.currentUser.Id)
              this.rerender();
              if (data.status === 200) {
                this.submitted = false;
                Swal.fire({
                  title: 'Epp Deactivated',
                  text: data.message,
                  type: 'success',
                }).then(() => {
                  this.submitted = false;
                  // this.reFresh.emit();
                });
              } else {
                Swal.fire({
                  title: data.error_code,
                  text: data.message,
                  type: 'error',
                });
              }
            },(error) => {                              //Error callback
              this.isLoading = false;
              Swal.fire({
                title: error.status,
                text: "Internal Server Error",
                type: "error",
              });
            });
              return false;
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              return false;
            }
          });
        });
        $('.update').on('click', (e) => {
          var msg;
          var value;
          if(e.target.getAttribute('isActive') == "1") {
            msg = 'You want Deactivate this EPP ?';
            value = '0';
          } else {
            msg = 'You want Activate this EPP ?';
            value = '1';
          }
          Swal.fire({
            title: "Are you sure?",
            text: msg,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonClass: "btn btn-danger mt-2",
            cancelButtonClass: "btn btn-success ml-2 mt-2",
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              this.isLoading = true;
              const data = {
                "UserSubscriptionMainID" : e.target.getAttribute('updateTpID'),
                "isActive" : value
              }
              this.gs
            .Inactive(e.target.getAttribute('updateEppID'), {"Admin_ID" : this.currentUser.Id,"UserID" :this.route.snapshot.params.UserID})
            .subscribe((data) => {
              this.rerender();
              this.isLoading = false;
              if (data.status === 200) {
                this.submitted = false;
                Swal.fire({
                  title: 'Epp Activated',
                  text: data.message,
                  type: 'success',
                }).then(() => {
                  this.submitted = false;
                  // this.reFresh.emit();
                });
              } else {
                Swal.fire({
                  title: data.error_code,
                  text: data.message,
                  type: 'error',
                });
              }
            },(error) => {                              //Error callback
              this.isLoading = false;
              Swal.fire({
                title: error.status,
                text: "Internal Server Error",
                type: "error",
              });
            });
              return false;
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              return false;
            }
          });
        });
      },
      // columnDefs: [{
      //   targets: [2],
      //   visible: true,

      // }]
    };
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  getusereppbyid() {
    this.isLoading = true;
    this.gs.getusereppbyid(this.route.snapshot.params.UserID)
    .subscribe(
      (res: any) => {
        this.isLoading = false;
        this.user = res.data[0];
        this.user.MobileNo = this.user.MobileNo.split(',');
        this.user.EmailID = this.user.EmailID.split(',');
        console.log(this.user);
      });
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
    // this.renderer.listen('document', 'click', (event) => {
    //   if (event.target.hasAttribute('editEppID')) {
    //     this.router.navigate([
    //       'edit/' + event.target.getAttribute('editEppID'),
    //     ]);
    //   }
    //   if (event.target.hasAttribute('deleteEppID')) {
    //     this.gs
    //       .deletbyid(event.target.getAttribute('deleteEppID'))
    //       .subscribe((data) => {
    //         this.rerender();
    //         if (data.status === 200) {
    //           this.submitted = false;
    //           Swal.fire({
    //             title: 'Epp Inactivated',
    //             text: data.message,
    //             type: 'success',
    //           }).then(() => {
    //             this.submitted = false;
    //             // this.reFresh.emit();
    //           });
    //         } else {
    //           Swal.fire({
    //             title: data.error_code,
    //             text: data.message,
    //             type: 'error',
    //           });
    //         }
    //       });
    //   }
    //   if (event.target.hasAttribute('updateEppID')) {
    //     this.gs
    //       .Inactive(event.target.getAttribute('updateEppID'))
    //       .subscribe((data) => {
    //         this.rerender();
    //         if (data.status === 200) {
    //           this.submitted = false;
    //           Swal.fire({
    //             title: 'Epp Activated',
    //             text: data.message,
    //             type: 'success',
    //           }).then(() => {
    //             this.submitted = false;
    //             // this.reFresh.emit();
    //           });
    //         } else {
    //           Swal.fire({
    //             title: data.error_code,
    //             text: data.message,
    //             type: 'error',
    //           });
    //         }
    //       });
    //   }
    // });
  }
}
